import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanDescField,
	CurrencyTextField,
	NumberTextField,
	TagsSelectField,
	useSettings
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ProjectsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { sysSettings, t } = useSettings();

	const canShowFinancialStats = sysSettings.projects_show_financial_stats === 'true';

	return (
		<>
			{canShowFinancialStats && (
				<>
					<Grid size={{ sm: 3, xs: 12 }}>
						{/* PLANNED VALUE */}
						<CurrencyTextField
							name="proj_value_planned"
							label={t('DETAILS_PROJECTS_FIELD_VALUE_PLANNED')}
							value={props.model.proj_value_planned}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={{ sm: 3, xs: 12 }}>
						{/* PLANNED EXPENSES */}
						<CurrencyTextField
							name="proj_expenses_planned"
							label={t('DETAILS_PROJECTS_FIELD_EXPENSES_PLANNED')}
							value={props.model.proj_expenses_planned}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={{ sm: 3, xs: 12 }}>
						{/* LENGTH HOURS PLANNED */}
						<NumberTextField
							name="proj_length_hours_planned"
							label={t('DETAILS_PROJECTS_FIELD_LENGTH_HOURS_PLANNED')}
							value={props.model.proj_length_hours_planned}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={{ sm: 3, xs: 12 }}>
						{/* OTHER EXPENSES */}
						<CurrencyTextField
							name="proj_expenses_other"
							label={t('DETAILS_PROJECTS_FIELD_EXPENSES_OTHER')}
							value={props.model.proj_expenses_other}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
				</>
			)}
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="proj_tags"
					label={t('DETAILS_PROJECTS_FIELD_TAGS')}
					value={props.model.proj_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="proj_warning_desc"
					label={t('DETAILS_PROJECTS_FIELD_WARNING')}
					value={props.model.proj_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="proj_blocked_desc"
					label={t('DETAILS_PROJECTS_FIELD_BLOCKED')}
					value={props.model.proj_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
